var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.newsletters.length > 0
    ? _c(
        "div",
        {
          staticClass: "newsletter-container",
          on: {
            mouseenter: _vm.stopNewsletters,
            mouseleave: _vm.startNewslettersShuffle,
            click: function($event) {
              return _vm.openUrl()
            }
          }
        },
        [
          _c("transition", [
            _c(
              "div",
              {
                key: _vm.activeNewsletter,
                staticClass: "newsletter-data-container"
              },
              [
                _c("div", { staticClass: "newsletter-header" }, [
                  _c(
                    "div",
                    {
                      class: [
                        "newsletter-type",
                        {
                          "drc-topic":
                            _vm.newsletters[_vm.activeNewsletter].platform ===
                            _vm.PLATFORMS.DRC
                        },
                        {
                          "gop-topic":
                            _vm.newsletters[_vm.activeNewsletter].platform ===
                            _vm.PLATFORMS.GOP
                        }
                      ]
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.newsletters[_vm.activeNewsletter].topic) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      class: [
                        "newsletter-category",
                        {
                          "drc-title":
                            _vm.newsletters[_vm.activeNewsletter].platform ===
                            _vm.PLATFORMS.DRC
                        },
                        {
                          "gop-title":
                            _vm.newsletters[_vm.activeNewsletter].platform ===
                            _vm.PLATFORMS.GOP
                        }
                      ]
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.newsletters[_vm.activeNewsletter].title) +
                          " "
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "newsletter-content" }, [
                  _c("div", { staticClass: "newsletter-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.newsMessageSize >
                          _vm.newsletters[_vm.activeNewsletter].message.length
                          ? _vm.newsletters[_vm.activeNewsletter].message
                          : _vm.newsletters[_vm.activeNewsletter].message.slice(
                              0,
                              _vm.newsMessageSize
                            ) + "..."
                      )
                    )
                  ])
                ]),
                !_vm.isMobileDevice
                  ? _c("button", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.newsletters[_vm.activeNewsletter]
                              .redirectionButtonText
                          ) +
                          " "
                      )
                    ])
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }